/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./logo.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./logo.component";
var styles_LogoComponent = [i0.styles];
var RenderType_LogoComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_LogoComponent, data: {} });
export { RenderType_LogoComponent as RenderType_LogoComponent };
export function View_LogoComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "img", [["alt", ""], ["src", "assets/images/logo.png"], ["style", "margin-left: 30px; "], ["title", ""]], null, null, null, null, null))], null, null); }
export function View_LogoComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-logo", [], [[8, "className", 0]], null, null, View_LogoComponent_0, RenderType_LogoComponent)), i1.ɵdid(1, 4833280, null, 0, i2.LogoComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).hostClass; _ck(_v, 0, 0, currVal_0); }); }
var LogoComponentNgFactory = i1.ɵccf("app-logo", i2.LogoComponent, View_LogoComponent_Host_0, { class: "class" }, {}, []);
export { LogoComponentNgFactory as LogoComponentNgFactory };
